// The backend sends every automation notification as ONE session event
// (EntityType.AUTOMATION); which notification it is lives in `method`.
// Source: core/model/automation/const/notification_type.py
export enum AutomationNotification {

    // an automation ran and actually changed something - only the user whose
    // change triggered it
    SUCCESS             = 'success',

    // the company hit the cascade limit and the change was NOT applied - only
    // the user who made the change
    LIMIT_REACHED       = 'limit-reached',

    // an automation switched itself off after N consecutive failed runs -
    // broadcast to the whole company, because whoever tripped the last error
    // is usually not the automation's owner
    DISABLED_ON_ERRORS  = 'disabled-on-errors',
}

// Carries {id, errorCount}. Deliberately NOT 'automation:updated', which every
// automations list answers with a refetch - this one arrives company-wide, so
// a refetch per listener would hit the API for every open list at once.
export const EVENT_BUS_AUTOMATION_DISABLED_ON_ERRORS = 'automation:disabled-on-errors'
